import * as z from "zod";

/**
 * Plain text node.
 */
const TextNodeSchema_ = z.object({
  type: z.literal("text"),
  value: z.string(),
});

/** Base type from schema inference (no index signature) */
type TextNodeBase = z.infer<typeof TextNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type TextNode = TextNodeBase & { [key: string]: unknown };

export const TextNodeSchema: z.ZodType<TextNode> = TextNodeSchema_;
